import { render, staticRenderFns } from "./IndexerLogs.vue?vue&type=template&id=61c66268&scoped=true&"
import script from "./IndexerLogs.vue?vue&type=script&lang=js&"
export * from "./IndexerLogs.vue?vue&type=script&lang=js&"
import style0 from "./IndexerLogs.vue?vue&type=style&index=0&id=61c66268&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61c66268",
  null
  
)

export default component.exports